import { notificationInsert } from '../service/todo';
// import { websocket } from '../constant'

export const OnlyNumber = (value) => {
    let regexItem = new RegExp('^[0-9]*$');
    let checkValid = regexItem.test(value);
    return !checkValid;
};

export const OnlySpecialChar = (value) => {
    let regexItem = new RegExp('^[!@#$%^&*()_-]+$');
    let checkValid = regexItem.test(value);
    return !checkValid;
};

export const OnlyAddress = (value) => {
    let regexItem = new RegExp('^[a-zA-Z0-9]*$');
    let checkValid = regexItem.test(value);
    return !checkValid;
};

export const OnlyAlphabets = (value) => {
    let regexItem = new RegExp('^[a-zA-Z ]*$');
    let checkValid = regexItem.test(value);
    return !checkValid;
};

export const OnlyNumberSpecialChar = (value) => {
    let regexItem = new RegExp('^[0-9]*$');
    let checkValid = regexItem.test(value);
    if (!checkValid) {
        regexItem = new RegExp('^[[\'"|.,=+?{}<>!0-9@#$%^&*()_-]+$', 'gm');
        checkValid = regexItem.test(value);
        if (!checkValid) {
            return false;
        } else return true;
    } else return true;
};
export const OnlyNumberAlphabetSpace = (value) => {
    //let regexItem = new RegExp('^(?=.*[a-zA-Z ])(?=.*[0-9])[A-Z a-z 0-9]+$');
    let regexItem = new RegExp('([0-9]+(\\.[0-9]+)?(\\s+)?[a-zA-Z])', 'gmi');
    let checkValid = regexItem.test(value);
    return !checkValid;
};

export async function NotificationTrigger(notifyObj, notifyTo, websocket, action = "SendOne") {
   

    if(websocket){
    websocket.send(
        JSON.stringify({
            type: 'string',
            action: action,
            to: notifyTo,
        })
    );}

    await notificationInsert(notifyObj);
}
